exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-content[data-v-6a105fac]{max-width:680px;color:#454545;border:1px solid #7c7c7c;border-radius:16px;padding:2rem}", ""]);

// exports
